module.exports = __webpack_public_path__ + "magnifying-glass-browser.332197bd32747633eacf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/magnifying-glass-browser.svg
// module id = 993
// module chunks = 2